import React from 'react';

import { useEarningsInsightsFilter } from '~/hooks/use-earnings-insights-filter/useEarningsInsightsFilter';
import { parseEarningsInsights } from '~/hooks/use-earnings-insights-filter/utils';
import { useIsEarningsInsightsEnabled } from '~/hooks/use-is-earnings-insights-enabled/useIsEarningsInsightsEnabled';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { EarningsInsightPill } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-pill/EarningsInsightPill';

import * as S from './EarningInsightsCell.styles';

interface EarningInsightsCellProps {
  earningsId: string;
  entityTag?: string;
}

export const EarningInsightsCell = ({
  earningsId,
  entityTag,
}: EarningInsightsCellProps) => {
  const isEarningsInsightsEnabled = useIsEarningsInsightsEnabled();

  const { data: earningsInsightsData = [], isFetching } =
    useEarningsInsightsFilter({
      body: { earnings_ids: [earningsId] },
      isEnabled: isEarningsInsightsEnabled,
    });
  const earningsInsight = parseEarningsInsights(earningsInsightsData);

  const hasData = !!earningsInsight && isEarningsInsightsEnabled && !!entityTag;

  if (isFetching) {
    return <S.StyledLoader />;
  }

  return hasData ? (
    <EarningsInsightPill
      entityTag={entityTag}
      earningsInsight={earningsInsight}
      isPreview={earningsInsight?.type === 'preview'}
      source={POSTHOG_TRACKING_SOURCES.EVENTS}
    />
  ) : null;
};
